import { gql } from "@apollo/client";

export const GET_WONDE_SYNC_FOR_SCHOOL = gql`
  query ($school: ID, $wondeSync: ID) {
    wondeSync(school: $school, wondeSync: $wondeSync) {
      id
      lastUpdated
      needsAction
      inProgress
      completed
      syncStatus
      school {
        name
      }
      reviews {
        id
        message
        contentType
        objectId
      }
    }
  }
`;

export const GET_WONDE_SYNC_REQUESTS = gql`
  query ($status: String, $search: String, $first: Int, $after: String) {
    wondeSyncRequests(
      status: $status
      search: $search
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          lastUpdated
          needsAction
          inProgress
          completed
          school {
            id
            name
            emailDomains {
              domain
            }
            subscriptionStatus
          }
          syncStatus
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    wondeSyncStatusOptions(search: $search) {
      code
      label
      count
      isDefault
      needsAction
      inProgress
      completed
    }
  }
`;
